(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weylan-reading-progress')) {
    customElements.define(
      'weylan-reading-progress',
      class extends HTMLElement {
        connectedCallback() {
          this.content = document.getElementById(this.dataset.contentId);
          this.bar = this.querySelector('span');
          this.update = this.update.bind(this);
          window.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.update);
          window.removeEventListener('resize', this.update);
        }

        update() {
          if (!this.content || !this.bar) return;
          const rect = this.content.getBoundingClientRect();
          const start = window.scrollY + rect.top - window.innerHeight * 0.45;
          const end = start + rect.height - window.innerHeight * 0.55;
          const progress = Math.min(1, Math.max(0, (window.scrollY - start) / Math.max(1, end - start)));
          this.bar.style.transform = `scaleX(${progress})`;
        }
      }
    );
  }

  if (!customElements.get('weylan-article-tools')) {
    customElements.define(
      'weylan-article-tools',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-copy-link]');
          this.status = this.querySelector('[role="status"]');
          this.button?.addEventListener('click', () => this.copyLink());
        }

        async copyLink() {
          if (!this.button) return;

          try {
            await navigator.clipboard.writeText(window.location.href);
            this.button.textContent = this.button.dataset.successLabel;
            if (this.status) this.status.textContent = this.button.dataset.successLabel;
            window.setTimeout(() => {
              this.button.textContent = this.button.dataset.defaultLabel;
              if (this.status) this.status.textContent = '';
            }, 2200);
          } catch (error) {
            window.prompt(this.button.dataset.defaultLabel, window.location.href);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-weylan-cart-page]');

    roots.forEach((root) => {
      if (root.dataset.cartPageReady === 'true') return;
      root.dataset.cartPageReady = 'true';

      const form = root.querySelector('.weylan-cart__form');
      const updateButton = root.querySelector('[data-cart-update]');
      const status = root.querySelector('[data-cart-page-status]');

      if (!form || !updateButton) return;

      const clampQuantity = (input, value) => {
        const minimum = Number(input.min || 1);
        const increment = Number(input.step || 1);
        const declaredMaximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
        const maximum = Number.isFinite(declaredMaximum)
          ? minimum + Math.floor((declaredMaximum - minimum) / increment) * increment
          : declaredMaximum;
        const numericValue = Number.isFinite(value) ? value : minimum;
        const steppedValue = minimum + Math.round((numericValue - minimum) / increment) * increment;

        return Math.min(maximum, Math.max(minimum, steppedValue));
      };

      const syncButtons = (input) => {
        const stepper = input.closest('.weylan-cart-item__stepper');
        if (!stepper) return;

        const minimum = Number(input.min || 1);
        const increment = Number(input.step || 1);
        const declaredMaximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
        const maximum = Number.isFinite(declaredMaximum)
          ? minimum + Math.floor((declaredMaximum - minimum) / increment) * increment
          : declaredMaximum;
        const value = Number(input.value);
        const decrease = stepper.querySelector('[data-quantity-decrease]');
        const increase = stepper.querySelector('[data-quantity-increase]');

        if (decrease) decrease.disabled = value - increment < minimum;
        if (increase) increase.disabled = value + increment > maximum;
      };

      const markDirty = () => {
        updateButton.disabled = false;
        if (status) status.textContent = root.dataset.cartChangesReady || '';
      };

      form.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
        if (!button) return;

        const stepper = button.closest('.weylan-cart-item__stepper');
        const input = stepper?.querySelector('[data-quantity-input]');
        if (!input) return;

        const increment = Number(input.step || 1);
        const direction = button.hasAttribute('data-quantity-increase') ? 1 : -1;
        input.value = clampQuantity(input, Number(input.value) + increment * direction);
        syncButtons(input);
        markDirty();
      });

      form.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input]');
        if (input) {
          input.value = clampQuantity(input, Number(input.value));
          syncButtons(input);
        }
        markDirty();
      });

      form.addEventListener('input', (event) => {
        if (event.target.matches('textarea[name="note"]')) markDirty();
      });

      form.addEventListener('submit', (event) => {
        if (form.dataset.submitting === 'true') {
          event.preventDefault();
          return;
        }

        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        if (status) {
          status.textContent = event.submitter?.getAttribute('name') === 'checkout'
            ? root.dataset.cartCheckout || ''
            : root.dataset.cartUpdating || '';
        }
      });

      form.querySelectorAll('[data-quantity-input]').forEach(syncButtons);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-weylan-product]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const variantData = root.querySelector('[data-variant-json]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const optionGroups = Array.from(root.querySelectorAll('[data-option-position]'));
      const variantInput = root.querySelector('[data-variant-id]');
      const productForm = root.querySelector('[data-product-form]');
      const formMessage = root.querySelector('[data-product-form-message]');
      const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
      const quantityControls = Array.from(root.querySelectorAll('[data-quantity-control]'));
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-product-compare-price]');
      const mobilePrice = root.querySelector('[data-mobile-price]');
      const saleBadge = root.querySelector('[data-product-sale]');
      const status = root.querySelector('[data-variant-status]');
      const purchaseState = root.querySelector('[data-purchase-state]');
      const skuWrap = root.querySelector('[data-product-sku-wrap]');
      const sku = root.querySelector('[data-product-sku]');
      const selectedConfiguration = root.querySelector('[data-selected-configuration]');
      const mobileVariant = root.querySelector('[data-mobile-variant]');
      const inquiryLinks = Array.from(root.querySelectorAll('[data-product-inquiry-link]'));
      const addButtons = root.querySelectorAll('[data-add-to-cart], [data-mobile-add]');
      const mainAddButton = root.querySelector('[data-add-to-cart]');
      const mobileBar = root.querySelector('[data-mobile-bar]');
      const mediaGrid = root.querySelector('[data-media-grid]');
      const mediaItems = Array.from(root.querySelectorAll('[data-media-id][data-media-type]'));
      const mediaThumbnails = Array.from(root.querySelectorAll('[data-media-thumbnail]'));
      const mediaCurrent = root.querySelector('[data-media-current]');
      const quantityInput = root.querySelector('[data-quantity-input]');
      let activeMediaIndex = Math.max(
        0,
        mediaItems.findIndex((item) => item.classList.contains('is-primary'))
      );

      const normalizeIndex = (index, length) => {
        if (!length) return 0;
        return (index + length) % length;
      };

      const selectMedia = (index, options = {}) => {
        if (!mediaItems.length) return;
        activeMediaIndex = normalizeIndex(index, mediaItems.length);

        mediaItems.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeMediaIndex;
          item.hidden = !isActive;
          item.classList.toggle('is-primary', isActive);

          if (!isActive) {
            item.querySelectorAll('video').forEach((video) => video.pause());
          }
        });

        mediaThumbnails.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === activeMediaIndex;
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
          if (isActive && options.scrollThumbnail !== false) {
            thumbnail.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }
        });

        if (mediaCurrent) mediaCurrent.textContent = String(activeMediaIndex + 1);
        if (options.focus) mediaGrid?.focus({ preventScroll: true });
      };

      const selectedOptions = () =>
        optionGroups.map((group) => group.querySelector('[data-option-value]:checked')?.value || '');

      const findVariant = (options) =>
        variants.find((variant) => variant.options.every((option, index) => option === options[index]));

      const setPurchaseControlsAvailable = (isAvailable) => {
        quantityControls.forEach((control) => {
          control.disabled = !isAvailable;
        });
        if (dynamicCheckout) dynamicCheckout.hidden = !isAvailable;
      };

      const setOptionState = (input, state) => {
        const label = input.nextElementSibling?.matches('[data-option-label]')
          ? input.nextElementSibling
          : null;
        const stateLabel = label?.querySelector('[data-option-state]');
        const isUnavailable = state === 'unavailable';
        const isNotOrderable = state === 'not_orderable';

        input.disabled = isUnavailable;
        input.dataset.optionState = state;
        label?.classList.toggle('is-unavailable', isUnavailable);
        label?.classList.toggle('is-not-orderable', isNotOrderable);

        if (stateLabel) {
          stateLabel.hidden = state === 'available';
          stateLabel.textContent = isNotOrderable
            ? root.dataset.notOrderableText
            : isUnavailable
              ? root.dataset.unavailableText
              : '';
        }
      };

      const updateAvailability = () => {
        const selected = selectedOptions();

        optionGroups.forEach((group, groupIndex) => {
          group.querySelectorAll('[data-option-value]').forEach((input) => {
            const matchingVariants = variants.filter((variant) => {
              for (let index = 0; index < groupIndex; index += 1) {
                if (variant.options[index] !== selected[index]) return false;
              }
              return variant.options[groupIndex] === input.value;
            });
            const state = !matchingVariants.length
              ? 'unavailable'
              : matchingVariants.some((variant) => variant.available)
                ? 'available'
                : 'not_orderable';
            setOptionState(input, state);
          });
        });
      };

      const updateVariant = () => {
        const selected = selectedOptions();
        const variant = findVariant(selected);
        const selectedSummary = selected.filter(Boolean).join(' / ');

        optionGroups.forEach((group) => {
          const label = group.querySelector('[data-selected-option]');
          const checked = group.querySelector('[data-option-value]:checked');
          if (label && checked) label.textContent = checked.value;
        });

        if (selectedConfiguration) selectedConfiguration.textContent = selectedSummary;
        if (mobileVariant) mobileVariant.textContent = selectedSummary;
        if (formMessage) formMessage.textContent = '';

        if (!variant) {
          const hadVariant = Boolean(variantInput?.value);
          if (variantInput) {
            variantInput.value = '';
            variantInput.disabled = true;
            if (hadVariant) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          root.dataset.selectedVariantId = '';
          root.dataset.availability = 'unavailable';
          setPurchaseControlsAvailable(false);
          addButtons.forEach((button) => {
            button.disabled = true;
            button.textContent = root.dataset.unavailableText;
          });
          if (status) status.textContent = root.dataset.unavailableText;
          if (comparePrice) comparePrice.hidden = true;
          if (saleBadge) saleBadge.hidden = true;
          if (skuWrap) skuWrap.hidden = true;
          purchaseState?.classList.add('is-unavailable');
          if (purchaseState) purchaseState.dataset.availability = 'unavailable';
          updateAvailability();
          return;
        }

        const variantChanged = variantInput && String(variantInput.value) !== String(variant.id);
        if (variantInput) {
          variantInput.disabled = false;
          variantInput.value = variant.id;
        }
        root.dataset.selectedVariantId = String(variant.id);
        root.dataset.priceAmount = String(variant.priceAmount);
        root.dataset.availability = variant.availabilityStatus;
        if (price) {
          price.textContent = variant.price;
          price.dataset.priceAmount = String(variant.priceAmount);
        }
        if (mobilePrice) mobilePrice.textContent = variant.price;

        if (comparePrice) {
          if (variant.compareAtPrice) {
            comparePrice.textContent = variant.compareAtPrice;
            comparePrice.dataset.compareAtPriceAmount = String(variant.compareAtPriceAmount);
            comparePrice.hidden = false;
          } else {
            comparePrice.dataset.compareAtPriceAmount = '0';
            comparePrice.hidden = true;
          }
        }
        if (saleBadge) saleBadge.hidden = !variant.compareAtPrice;
        if (sku) sku.textContent = variant.sku || '';
        if (skuWrap) skuWrap.hidden = !variant.sku;
        purchaseState?.classList.toggle('is-unavailable', variant.availabilityStatus === 'not_orderable');
        if (purchaseState) purchaseState.dataset.availability = variant.availabilityStatus;

        addButtons.forEach((button) => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? root.dataset.addText : root.dataset.notOrderableText;
        });
        setPurchaseControlsAvailable(variant.available);

        if (status) {
          status.textContent = variant.availabilityText;
        }

        if (variant.mediaId && mediaGrid) {
          const target = mediaGrid.querySelector(`[data-media-id="${variant.mediaId}"]`);
          if (target) {
            selectMedia(Number(target.dataset.mediaIndex), { scrollThumbnail: true });
          }
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        inquiryLinks.forEach((link) => {
          const destination = new URL(link.href, window.location.origin);
          if (!destination.searchParams.has('inquiry_path')) return;
          destination.searchParams.set('inquiry_path', `${root.dataset.productUrl}?variant=${variant.id}`);
          link.href = `${destination.pathname}${destination.search}${destination.hash}`;
        });
        if (variantChanged) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateAvailability();
      };

      optionGroups.forEach((group) => {
        group.addEventListener('change', updateVariant);
      });

      productForm?.addEventListener('submit', (event) => {
        const canSubmit = Boolean(variantInput?.value) && !variantInput.disabled && !mainAddButton?.disabled;
        if (canSubmit) return;

        event.preventDefault();
        if (formMessage) {
          formMessage.textContent = root.dataset.availability === 'not_orderable'
            ? root.dataset.notOrderableText
            : root.dataset.unavailableText;
          formMessage.focus({ preventScroll: true });
        }
      });

      const normalizeQuantity = () => {
        if (!quantityInput) return;
        const value = Math.floor(Number(quantityInput.value));
        quantityInput.value = String(Number.isFinite(value) ? Math.max(1, value) : 1);
      };

      quantityInput?.addEventListener('change', normalizeQuantity);
      quantityInput?.addEventListener('blur', normalizeQuantity);

      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        normalizeQuantity();
        quantityInput.value = String(Math.max(1, Number(quantityInput.value) - 1));
      });

      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        normalizeQuantity();
        quantityInput.value = String(Number(quantityInput.value) + 1);
      });

      const setMobileBarVisible = (visible) => {
        if (!mobileBar) return;
        mobileBar.classList.toggle('is-visible', visible);
        mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };

      if (mobileBar && mainAddButton) {
        let mobileBarFrame;
        const updateMobileBarFromPosition = () => {
          window.cancelAnimationFrame(mobileBarFrame);
          mobileBarFrame = window.requestAnimationFrame(() => {
            const buttonRect = mainAddButton.getBoundingClientRect();
            setMobileBarVisible(
              window.matchMedia('(max-width: 749px)').matches && buttonRect.bottom < 0
            );
          });
        };

        if ('IntersectionObserver' in window) {
          const mobileBarObserver = new IntersectionObserver(updateMobileBarFromPosition);
          mobileBarObserver.observe(mainAddButton);
        }

        window.addEventListener('scroll', updateMobileBarFromPosition, { passive: true });
        window.addEventListener('resize', updateMobileBarFromPosition);
        updateMobileBarFromPosition();
      }

      mediaThumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          selectMedia(Number(thumbnail.dataset.mediaIndex), { focus: false, scrollThumbnail: false });
        });
      });

      root.querySelector('[data-media-previous]')?.addEventListener('click', () => {
        selectMedia(activeMediaIndex - 1);
      });

      root.querySelector('[data-media-next]')?.addEventListener('click', () => {
        selectMedia(activeMediaIndex + 1);
      });

      mediaGrid?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          selectMedia(activeMediaIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          selectMedia(activeMediaIndex + 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          selectMedia(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          selectMedia(mediaItems.length - 1);
        }
      });

      let swipeStart = null;
      mediaGrid?.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || event.target.closest('button, video, model-viewer, iframe')) return;
        swipeStart = { x: event.clientX, y: event.clientY };
      });

      mediaGrid?.addEventListener('pointerup', (event) => {
        if (!swipeStart) return;
        const deltaX = event.clientX - swipeStart.x;
        const deltaY = event.clientY - swipeStart.y;
        swipeStart = null;

        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        selectMedia(activeMediaIndex + (deltaX < 0 ? 1 : -1));
      });

      mediaGrid?.addEventListener('pointercancel', () => {
        swipeStart = null;
      });

      const lightbox = root.querySelector('[data-product-lightbox]');
      const lightboxImage = lightbox?.querySelector('img');
      const lightboxCurrent = lightbox?.querySelector('[data-lightbox-current]');
      const lightboxTriggers = Array.from(root.querySelectorAll('[data-lightbox-trigger]'));
      const lightboxThumbnails = Array.from(root.querySelectorAll('[data-lightbox-thumbnail]'));
      let activeLightboxIndex = 0;
      let lightboxReturnFocus = null;

      const selectLightboxImage = (index) => {
        if (!lightboxImage || !lightboxTriggers.length) return;
        activeLightboxIndex = normalizeIndex(index, lightboxTriggers.length);
        const trigger = lightboxTriggers[activeLightboxIndex];

        lightboxImage.src = trigger.dataset.lightboxSrc;
        lightboxImage.alt = trigger.dataset.lightboxAlt || '';
        if (lightboxCurrent) lightboxCurrent.textContent = String(activeLightboxIndex + 1);

        lightboxThumbnails.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === activeLightboxIndex;
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
          if (isActive) {
            thumbnail.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }
        });
      };

      lightboxTriggers.forEach((button) => {
        button.addEventListener('click', () => {
          if (!lightbox || !lightboxImage) return;
          lightboxReturnFocus = button;
          selectLightboxImage(Number(button.dataset.lightboxIndex));
          lightbox.showModal();
        });
      });

      lightboxThumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          selectLightboxImage(Number(thumbnail.dataset.lightboxIndex));
        });
      });

      root.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => {
        selectLightboxImage(activeLightboxIndex - 1);
      });

      root.querySelector('[data-lightbox-next]')?.addEventListener('click', () => {
        selectLightboxImage(activeLightboxIndex + 1);
      });

      root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });

      lightbox?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          selectLightboxImage(activeLightboxIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          selectLightboxImage(activeLightboxIndex + 1);
        }
      });

      lightbox?.addEventListener('close', () => {
        lightboxReturnFocus?.focus({ preventScroll: true });
      });

      selectMedia(activeMediaIndex, { scrollThumbnail: false });
      updateAvailability();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weylan-inquiry-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contextParameterNames = ['inquiry_source', 'inquiry_title', 'inquiry_path', 'inquiry_project'];

    const readInquiryContext = () => {
      const parameters = new URLSearchParams(window.location.search);
      const sourceType = parameters.get('inquiry_source');
      const rawTitle = parameters.get('inquiry_title');
      const rawPath = parameters.get('inquiry_path');
      const projectType = parameters.get('inquiry_project');
      if (!['product', 'collection'].includes(sourceType) || !rawTitle || !rawPath) return null;

      const title = rawTitle.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 140);
      if (!title) return null;

      let sourceUrl;
      try {
        sourceUrl = new URL(rawPath, window.location.origin);
      } catch {
        return null;
      }

      if (sourceUrl.origin !== window.location.origin) return null;
      const expectedSegment = sourceType === 'product' ? '/products/' : '/collections/';
      if (!sourceUrl.pathname.includes(expectedSegment)) return null;

      let normalizedPath = sourceUrl.pathname;
      const variantId = sourceUrl.searchParams.get('variant');
      if (sourceType === 'product' && variantId && /^\d+$/.test(variantId)) {
        normalizedPath += `?variant=${variantId}`;
      }

      return { sourceType, title, normalizedPath, projectType };
    };

    const clearInquiryContext = (form) => {
      form.querySelectorAll('[data-inquiry-source-type], [data-inquiry-source-title], [data-inquiry-source-path]').forEach(
        (input) => {
          input.value = '';
          input.disabled = true;
        }
      );
      const context = form.querySelector('[data-inquiry-context]');
      if (context) context.hidden = true;

      const url = new URL(window.location.href);
      contextParameterNames.forEach((name) => url.searchParams.delete(name));
      window.history.replaceState({}, '', url);
    };

    const applyInquiryContext = (form) => {
      const inquiryContext = readInquiryContext();
      if (!inquiryContext) return;

      const sourceType = form.querySelector('[data-inquiry-source-type]');
      const sourceTitle = form.querySelector('[data-inquiry-source-title]');
      const sourcePath = form.querySelector('[data-inquiry-source-path]');
      const context = form.querySelector('[data-inquiry-context]');
      const contextLink = form.querySelector('[data-inquiry-context-link]');
      const removeButton = form.querySelector('[data-inquiry-context-remove]');
      if (!sourceType || !sourceTitle || !sourcePath || !context || !contextLink) return;

      sourceType.value = inquiryContext.sourceType;
      sourceTitle.value = inquiryContext.title;
      sourcePath.value = inquiryContext.normalizedPath;
      sourceType.disabled = false;
      sourceTitle.disabled = false;
      sourcePath.disabled = false;
      contextLink.textContent = inquiryContext.title;
      contextLink.href = inquiryContext.normalizedPath;
      context.hidden = false;

      const projectType = form.querySelector('[data-inquiry-project-type]');
      if (projectType && inquiryContext.projectType) {
        const hasProjectOption = [...projectType.options].some((option) => option.value === inquiryContext.projectType);
        if (hasProjectOption) projectType.value = inquiryContext.projectType;
      }

      removeButton?.addEventListener('click', () => clearInquiryContext(form), { once: true });
    };

    const updateSpecificationGroups = (form) => {
      const projectType = form.querySelector('[data-inquiry-project-type]');
      const groups = [...form.querySelectorAll('[data-spec-group]')];
      if (!projectType || groups.length === 0) return;

      const selectedValue = projectType.value;
      groups.forEach((group) => {
        const groupType = group.dataset.specGroup;
        const isWholeRoom = selectedValue === 'Whole-room project';
        const isVisible =
          isWholeRoom ||
          (groupType === 'lighting' && selectedValue === 'Lighting specification') ||
          (groupType === 'furniture' && selectedValue === 'Furniture selection');
        group.hidden = !isVisible;
        group.disabled = !isVisible;
      });
    };

    const setupInquiryForms = (scope = document) => {
      scope.querySelectorAll('.weylan-inquiry__form').forEach((form) => {
        if (form.dataset.inquiryReady === 'true') return;
        form.dataset.inquiryReady = 'true';
        applyInquiryContext(form);
        const projectType = form.querySelector('[data-inquiry-project-type]');
        projectType?.addEventListener('change', () => updateSpecificationGroups(form));
        updateSpecificationGroups(form);
      });
    };

    const focusFeedback = (scope = document) => {
      scope.querySelectorAll('[data-inquiry-feedback]').forEach((feedback) => {
        if (feedback.dataset.focused === 'true') return;
        feedback.dataset.focused = 'true';
        window.requestAnimationFrame(() => feedback.focus());
      });
    };

    const selectProjectPath = (event) => {
      const trigger = event.target.closest('[data-inquiry-project]');
      if (!trigger) return;

      const targetSelector = trigger.getAttribute('href');
      const selectedProject = trigger.dataset.inquiryProject;
      if (!targetSelector?.startsWith('#') || !selectedProject) return;

      const target = document.querySelector(targetSelector);
      const projectType = target?.querySelector('[data-inquiry-project-type]');
      if (!target || !projectType) return;

      const matchingOption = [...projectType.options].some((option) => option.value === selectedProject);
      if (!matchingOption) return;

      event.preventDefault();
      projectType.value = selectedProject;
      projectType.dispatchEvent(new Event('change', { bubbles: true }));
      target.scrollIntoView({ block: 'start' });
      window.requestAnimationFrame(() => projectType.focus({ preventScroll: true }));
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          setupInquiryForms();
          focusFeedback();
        },
        { once: true }
      );
    } else {
      setupInquiryForms();
      focusFeedback();
    }

    if (!window.weylanInquiryProjectLinksBound) {
      window.weylanInquiryProjectLinksBound = true;
      document.addEventListener('click', selectProjectPath);
    }

    document.addEventListener('shopify:section:load', (event) => {
      setupInquiryForms(event.target);
      focusFeedback(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weylan-product-before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-before-after]').forEach((comparison) => {
    if (comparison.dataset.initialized === 'true') return;
    comparison.dataset.initialized = 'true';
    comparison.querySelector('[data-before-after-range]')?.addEventListener('input', (event) => {
      comparison.style.setProperty('--position', `${event.target.value}%`);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weylan-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weylan-product-recommendations')) {
    customElements.define(
      'weylan-product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.innerHTML.trim() || this.dataset.loading === 'true') return;
          this.dataset.loading = 'true';
          this.setAttribute('aria-busy', 'true');

          fetch(this.dataset.url)
            .then((response) => {
              if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
              return response.text();
            })
            .then((text) => {
              const container = document.createElement('div');
              container.innerHTML = text;
              const recommendations = container.querySelector('weylan-product-recommendations');

              if (recommendations?.innerHTML.trim()) {
                this.innerHTML = recommendations.innerHTML;
                this.setAttribute('aria-busy', 'false');
              } else {
                this.remove();
              }
            })
            .catch(() => this.remove());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
